export default __webpack_public_path__ + "static/redirectImage-56c69b011db2c3196775998efc0480d7.png";